// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"8b0ade93","354":"e552aa41","363":"7e0da7b0","453":"bebd0926","625":"9864e733","917":"437a4cdc"}[chunkId] + ".chunk.js";
};